import {
    Box,
    Heading,
    Divider,
    Button,
    Flex,
    Badge,
} from "@chakra-ui/react";
import { useState } from "react";
import { useAuth } from "../../auth/AuthContext";
import AddAddressForm from "./AddAddressForm";
import ActiveAddressMap from "./ActiveAddressMap";
import AddressList from "./AdressesList";
import PickupAddressList from "./RealTime/PickupAddressList";
import { useCustomTheme } from "../../contexts/CustomThemeContext";

const cardsBorderRadii = "8px";

const DeliveryAddressPage = () => {
    const { userSettings } = useAuth();
    const { theme } = useCustomTheme();

    const addresses = userSettings?.addresses ?? [];
    const currentAddress = addresses.find(a => a.isCurrent);
    const pickupAddress = addresses.find(a => a.isPickup);

    const [showAddForm, setShowAddForm] = useState(addresses.length === 0);

    const isShopUser = userSettings?.role === "shop";

    return (
        <Flex
            width="100%"
            bg={theme.surface}
            justifyContent="center"
            px={{ base: 3, md: 4 }}
            py={{ base: 3, md: 4 }}
        >
            <Box
                w="100%"
                maxW="100%"
                borderRadius={cardsBorderRadii}
                bg={theme.surface}
                borderColor={theme.border}
                boxShadow={theme.shadowSm}
            >
                <Flex
                    justify="space-between"
                    align={{ base: "flex-start", sm: "center" }}
                    gap={2}
                    mb={3}
                    flexWrap="wrap"
                >
                    <Heading size="md" color={theme.text}>
                        Delivery Address
                    </Heading>

                    {currentAddress && (
                        <Badge
                            borderRadius={cardsBorderRadii}
                            px={3}
                            py={1}
                            colorScheme="green"
                            variant="subtle"
                        >
                            Active address set
                        </Badge>
                    )}
                </Flex>

                <Divider mb={4} borderColor={theme.divider} />

                {/* 🗺 DELIVERY MAP */}
                <Box
                    borderRadius={cardsBorderRadii}
                    overflow="hidden"
                    border="1px solid"
                    borderColor={theme.border}
                    bg={theme.surfaceAlt}
                    boxShadow={theme.shadowSm}
                    mb={4}
                >
                    <ActiveAddressMap address={currentAddress} />
                </Box>

                {/* DELIVERY ADDRESS LIST (UNCHANGED) */}
                {addresses.length > 0 && (
                    <Box
                        borderRadius={cardsBorderRadii}
                        border="1px solid"
                        borderColor={theme.border}
                        bg={theme.surface}
                        boxShadow={theme.shadowSm}
                        p={{ base: 3, md: 4 }}
                    >
                        <AddressList addresses={addresses} />
                    </Box>
                )}

                {!showAddForm && (
                    <Button
                        mt={4}
                        onClick={() => setShowAddForm(true)}
                        color={theme.textOnPrimary}
                        bgImage={theme.gradients.primaryButton}
                        _hover={{ bgImage: theme.gradients.primaryButtonHover }}
                        boxShadow={theme.shadowSm}
                        w={{ base: "100%", sm: "auto" }}
                    >
                        + Add new address
                    </Button>
                )}
                {showAddForm && (
                    <Box
                        mt={4}
                        borderRadius={cardsBorderRadii}
                        border="1px solid"
                        borderColor={theme.border}
                        bg={theme.surfaceAlt}
                        boxShadow={theme.shadowSm}
                        p={{ base: 3, md: 4 }}
                    >
                        <AddAddressForm onDone={() => setShowAddForm(false)} />
                    </Box>
                )}
            </Box>
        </Flex>
    );
};

export default DeliveryAddressPage;